export type StatusChipKey =
  | "active"
  | "connected"
  | "draft"
  | "inactive"
  | "needs_auth"
  | "needsAuth";

export interface StatusChipStyle {
  backgroundClassName: string;
  borderClassName: string;
  textClassName: string;
  dotClassName: string;
}

const STATUS_CHIP_STYLES: Record<StatusChipKey, StatusChipStyle> = {
  active: {
    backgroundClassName: "bg-[#F0F9EC]",
    borderClassName: "border-[#CDE9C3]",
    textClassName: "text-[#65A30D]",
    dotClassName: "bg-[#65A30D]",
  },
  connected: {
    backgroundClassName: "bg-[#F0F9EC]",
    borderClassName: "border-[#CDE9C3]",
    textClassName: "text-[#65A30D]",
    dotClassName: "bg-[#65A30D]",
  },
  draft: {
    backgroundClassName: "bg-[#F3F4F6]",
    borderClassName: "border-[#D6D3D1]",
    textClassName: "text-[#444746]",
    dotClassName: "bg-[#4C6075]",
  },
  inactive: {
    backgroundClassName: "bg-[#F3F4F6]",
    borderClassName: "border-[#D6D3D1]",
    textClassName: "text-[#444746]",
    dotClassName: "bg-[#4C6075]",
  },
  needs_auth: {
    backgroundClassName: "bg-[#FEFCE8]",
    borderClassName: "border-[#FDE68A]",
    textClassName: "text-[#D97706]",
    dotClassName: "bg-[#EAB308]",
  },
  needsAuth: {
    backgroundClassName: "bg-[#FEFCE8]",
    borderClassName: "border-[#FDE68A]",
    textClassName: "text-[#D97706]",
    dotClassName: "bg-[#EAB308]",
  },
};

export function getStatusChipStyle(status: StatusChipKey): StatusChipStyle {
  return STATUS_CHIP_STYLES[status];
}
